<template>
	<svg class="w-auto h-8 fill-current sm:h-10 filter drop-shadow-lg" viewBox="0 0 79 78" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M39.5344 23.1602L62.2439 0.453369L78.2719 16.48L55.5627 39.1867L78.2719 61.8934L62.2439 77.92L39.5344 55.2132L16.825 77.92L0.796875 61.8934L23.5061 39.1867L0.796875 16.48L16.825 0.453369L39.5344 23.1602Z" />
	</svg>
</template>

<script>
export default {
	name: 'IconCross',
}
</script>
